// // src/components/RegionAssignmentTableRow.jsx
// import React, { useState } from 'react';
// import axios from 'axios';
// import toast from 'react-hot-toast';
// import { ChevronDown, ChevronUp } from 'lucide-react';
// import { Admin_Parivartan_BDM, Admin_Regions_API } from '../../../../constants';
// import { assignmentPropType } from '../hooks/useGroupedRegionData';
// import PropTypes from 'prop-types';
// import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

// const RegionAssignmentTableRow = ({
//   employeeId,
//   assignments = [],
//   refetch,
//   isExpanded,
//   onToggleExpand,
// }) => {
//   // Modal state for status toggle
//   const [statusModal, setStatusModal] = useState({
//     open: false,
//     regionId: '',
//     currentStatus: '',
//   });

//   // Modal state for delete
//   const [deleteModal, setDeleteModal] = useState({
//     open: false,
//     assignmentId: null,
//     regionName: '',
//   });

//   const [loading, setLoading] = useState(false);

//   const handleToggleStatus = (regionId, currentStatus) => {
//     setStatusModal({ open: true, regionId, currentStatus });
//   };

//   const confirmToggleStatus = async () => {
//     setLoading(true);
//     try {
//       const payload = {
//         RegionId: statusModal.regionId,
//         is_active:
//           statusModal.currentStatus === 'Active' ? 'Inactive' : 'Active',
//       };
//       const res = await axios.put(
//         `${Admin_Regions_API}/${employeeId}/status`,
//         payload
//       );
//       if (res.data.success) {
//         toast.success('Status updated');
//         refetch();
//       } else {
//         toast.error(res.data.message || 'Failed to update status');
//       }
//     } catch {
//       toast.error('Failed to update status');
//     } finally {
//       setLoading(false);
//       setStatusModal({ open: false, regionId: '', currentStatus: '' });
//     }
//   };

//   const handleDeleteAssignment = (id, regionName) => {
//     setDeleteModal({ open: true, assignmentId: id, regionName });
//   };

//   const confirmDeleteAssignment = async () => {
//     if (!deleteModal.assignmentId) return;
//     setLoading(true);
//     try {
//       const res = await axios.delete(
//         `${Admin_Parivartan_BDM}/${deleteModal.assignmentId}`
//       );
//       if (res.data.success) {
//         toast.success('Assignment deleted');
//         refetch();
//       } else {
//         toast.error(res.data.message || 'Failed to delete assignment');
//       }
//     } catch {
//       toast.error('Failed to delete assignment');
//     } finally {
//       setLoading(false);
//       setDeleteModal({ open: false, assignmentId: null, regionName: '' });
//     }
//   };

//   // Defensive: handle empty assignments array
//   const employeeName =
//     Array.isArray(assignments) && assignments.length > 0
//       ? assignments[0].EmployeeName
//       : '';
//   const employeeIdDisplay =
//     Array.isArray(assignments) && assignments.length > 0
//       ? assignments[0].EmployeeId
//       : '';
//       console.log('Assignments:', assignments);
//       const safeAssignments = Array.isArray(assignments) ? assignments : [];


//   return (
//     <>
//       {/* <tr className="hover cursor-pointer" onClick={onToggleExpand}>
//         <td colSpan={6} className="p-4">
//           <div className="flex justify-between items-center">
//             <div>
//               <div className="font-semibold text-base">{employeeName}</div>
//               <div className="text-sm text-gray-500">
//                 ID: {employeeIdDisplay}
//               </div>
//             </div>
//             <div className="flex items-center gap-1 text-sm text-gray-500 select-none">
//               <span>Total Regions: {safeAssignments.length}</span>
//               {isExpanded ? (
//                 <ChevronUp size={16} className="transition-transform" />
//               ) : (
//                 <ChevronDown size={16} className="transition-transform" />
//               )}
//             </div>
//           </div>
//         </td>
//       </tr>

//       {isExpanded && (
//         <tr>
//           <td colSpan={6} className="p-0">
//             <div className="bg-base-200 rounded-b-lg p-4 border-t border-base-300 shadow-sm animate-fade-in mb-4">
//               <table className="table w-full text-sm">
//                 <thead>
//                   <tr>
//                     <th>Region</th>
//                     <th>Project</th>
//                     <th>Role</th>
//                     <th>Status</th>
//                     <th className="text-right">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {assignments.map((a) => (
//                     <tr key={a.id}>
//                       <td>{a.RegionName}</td>
//                       <td>{a.Project}</td>
//                       <td>{a.role}</td>
//                       <td>
//                         <span
//                           className={`badge ${
//                             a.is_active === 'Active'
//                               ? 'badge-success'
//                               : 'badge-ghost'
//                           }`}
//                         >
//                           {a.is_active}
//                         </span>
//                       </td>
//                       <td className="text-right space-x-2">
//                         <button
//                           className="btn btn-xs btn-outline btn-info"
//                           onClick={() =>
//                             handleToggleStatus(a.RegionId, a.is_active)
//                           }
//                         >
//                           {a.is_active === 'Active' ? 'Deactivate' : 'Activate'}
//                         </button>
//                         <button
//                           className="btn btn-xs btn-outline btn-error"
//                           onClick={() =>
//                             handleDeleteAssignment(a.id, a.RegionName)
//                           }
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </td>
//         </tr>
//       )}

//       {/* Toggle Status Modal */}
//      {/* {statusModal.open && (
//         <div className="modal modal-open">
//           <div className="modal-box max-w-sm">
//             <h3 className="font-bold text-lg mb-4">
//               {statusModal.currentStatus === 'Active'
//                 ? 'Deactivate'
//                 : 'Activate'}{' '}
//               Region Assignment
//             </h3>
//             <p>
//               Are you sure you want to{' '}
//               <span className="font-semibold">
//                 {statusModal.currentStatus === 'Active'
//                   ? 'deactivate'
//                   : 'activate'}
//               </span>{' '}
//               this region assignment?
//             </p>
//             <div className="modal-action">
//               <button
//                 className="btn btn-ghost"
//                 onClick={() =>
//                   setStatusModal({
//                     open: false,
//                     regionId: '',
//                     currentStatus: '',
//                   })
//                 }
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button
//                 className={`btn ${
//                   statusModal.currentStatus === 'Active'
//                     ? 'btn-error'
//                     : 'btn-success'
//                 }`}
//                 onClick={confirmToggleStatus}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span className="loading loading-spinner loading-sm"></span>
//                     Saving...
//                   </>
//                 ) : statusModal.currentStatus === 'Active' ? (
//                   'Deactivate'
//                 ) : (
//                   'Activate'
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Assignment Modal */}
//     {/*  {deleteModal.open && (
//         <div className="modal modal-open">
//           <div className="modal-box max-w-sm">
//             <h3 className="font-bold text-lg mb-4">Delete Region Assignment</h3>
//             <p>
//               Are you sure you want to delete the assignment for region{' '}
//               <span className="font-semibold">{deleteModal.regionName}</span>?
//             </p>
//             <div className="modal-action">
//               <button
//                 className="btn btn-ghost"
//                 onClick={() =>
//                   setDeleteModal({
//                     open: false,
//                     assignmentId: null,
//                     regionName: '',
//                   })
//                 }
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn btn-error"
//                 onClick={confirmDeleteAssignment}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span className="loading loading-spinner loading-sm"></span>
//                     Deleting...
//                   </>
//                 ) : (
//                   'Delete'
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )} 
// */}
//           {/* Main Row */}
//       <TableRow
//         hover
//         sx={{ cursor: 'pointer' }}
//         onClick={onToggleExpand}
//       >
//         <TableCell colSpan={6}>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Box>
//               <Typography fontWeight={600} fontSize="1rem">
//                 {employeeName}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 ID: {employeeIdDisplay}
//               </Typography>
//             </Box>
//             <Box display="flex" alignItems="center" gap={1}>
//               <Typography variant="body2" color="text.secondary">
//                 Total Regions: {safeAssignments.length}
//               </Typography>
//               {isExpanded ? (
//                 <ChevronUp size={18} />
//               ) : (
//                 <ChevronDown size={18} />
//               )}
//             </Box>
//           </Box>
//         </TableCell>
//       </TableRow>

//       {/* Expanded Region Assignments */}
//       {isExpanded && (
//         <TableRow>
//           <TableCell colSpan={6} sx={{ p: 0 }}>
//             <Box
//               sx={{
//                 bgcolor: 'grey.100',
//                 borderBottomLeftRadius: 8,
//                 borderBottomRightRadius: 8,
//                 p: 2,
//                 borderTop: 1,
//                 borderColor: 'grey.300',
//                 boxShadow: 1,
//                 mb: 2,
//                 animation: 'fadeIn 0.3s',
//               }}
//             >
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Region</TableCell>
//                     <TableCell>Project</TableCell>
//                     <TableCell>Role</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="right">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {assignments.map((a) => (
//                     <TableRow key={a.id}>
//                       <TableCell>{a.RegionName}</TableCell>
//                       <TableCell>{a.Project}</TableCell>
//                       <TableCell>{a.role}</TableCell>
//                       <TableCell>
//                         <Chip
//                           label={a.is_active}
//                           color={a.is_active === 'Active' ? 'success' : 'default'}
//                           size="small"
//                           variant={a.is_active === 'Active' ? 'filled' : 'outlined'}
//                         />
//                       </TableCell>
//                       <TableCell align="right">
//                         <Stack direction="row" spacing={1} justifyContent="flex-end">
//                           <Button
//                             size="small"
//                             variant="outlined"
//                             color={a.is_active === 'Active' ? 'warning' : 'success'}
//                             onClick={() =>
//                               handleToggleStatus(a.RegionId, a.is_active)
//                             }
//                           >
//                             {a.is_active === 'Active' ? 'Deactivate' : 'Activate'}
//                           </Button>
//                           <Button
//                             size="small"
//                             variant="outlined"
//                             color="error"
//                             onClick={() =>
//                               handleDeleteAssignment(a.id, a.RegionName)
//                             }
//                           >
//                             Delete
//                           </Button>
//                         </Stack>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </Box>
//           </TableCell>
//         </TableRow>
//       )}

//       {/* Toggle Status Modal */}
//       <Dialog
//         open={statusModal.open}
//         onClose={() =>
//           setStatusModal({ open: false, regionId: '', currentStatus: '' })
//         }
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           {statusModal.currentStatus === 'Active'
//             ? 'Deactivate'
//             : 'Activate'}{' '}
//           Region Assignment
//         </DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to{' '}
//             <Box component="span" fontWeight="bold" display="inline">
//               {statusModal.currentStatus === 'Active'
//                 ? 'deactivate'
//                 : 'activate'}
//             </Box>{' '}
//             this region assignment?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() =>
//               setStatusModal({ open: false, regionId: '', currentStatus: '' })
//             }
//             disabled={loading}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={confirmToggleStatus}
//             color={statusModal.currentStatus === 'Active' ? 'error' : 'success'}
//             disabled={loading}
//             variant="contained"
//           >
//             {loading ? (
//               <>
//                 <CircularProgress size={18} sx={{ mr: 1 }} />
//                 Saving...
//               </>
//             ) : statusModal.currentStatus === 'Active' ? (
//               'Deactivate'
//             ) : (
//               'Activate'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Assignment Modal */}
//       <Dialog
//         open={deleteModal.open}
//         onClose={() =>
//           setDeleteModal({
//             open: false,
//             assignmentId: null,
//             regionName: '',
//           })
//         }
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>Delete Region Assignment</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete the assignment for region{' '}
//             <Box component="span" fontWeight="bold" display="inline">
//               {deleteModal.regionName}
//             </Box>
//             ?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() =>
//               setDeleteModal({
//                 open: false,
//                 assignmentId: null,
//                 regionName: '',
//               })
//             }
//             disabled={loading}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={confirmDeleteAssignment}
//             color="error"
//             disabled={loading}
//             variant="contained"
//           >
//             {loading ? (
//               <>
//                 <CircularProgress size={18} sx={{ mr: 1 }} />
//                 Deleting...
//               </>
//             ) : (
//               'Delete'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
         

//     </>
//   );
// };

// RegionAssignmentTableRow.propTypes = {
//   employeeId: PropTypes.string.isRequired,
//   assignments: PropTypes.arrayOf(assignmentPropType).isRequired,
//   refetch: PropTypes.func.isRequired,
//   isExpanded: PropTypes.bool.isRequired,
//   onToggleExpand: PropTypes.func.isRequired,
// };

// export default RegionAssignmentTableRow;


import React, { useState } from 'react';
import axiosInstance from 'axios';
import toast from 'react-hot-toast';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Admin_Parivartan_BDM, Admin_Regions_API } from '../../../../constants';
import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

const RegionAssignmentTableRow = ({
  employeeId,
  assignments =[],
  refetch,
  isExpanded,
  onToggleExpand,
}) => {
  // Modal state for status toggle
  const [statusModal, setStatusModal] = useState({
    open: false,
    regionId: '',
    currentStatus: '',
  });

  // Modal state for delete
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    assignmentId: null,
    regionName: '',
  });

  const [loading, setLoading] = useState(false);

  const handleToggleStatus = (regionId, currentStatus) => {
    setStatusModal({ open: true, regionId, currentStatus });
  };

  const confirmToggleStatus = async () => {
    setLoading(true);
    try {
      const payload = {
        RegionId: statusModal.regionId,
        is_active:
          statusModal.currentStatus === 'Active' ? 'Inactive' : 'Active',
      };
      const res = await axiosInstance.put(
        `${Admin_Regions_API}/${employeeId}/status`,
        payload,
      );
      if (res.data.success) {
        toast.success('Status updated');
        refetch();
      } else {
        toast.error(res.data.message || 'Failed to update status');
      }
    } catch {
      toast.error('Failed to update status');
    } finally {
      setLoading(false);
      setStatusModal({ open: false, regionId: '', currentStatus: '' });
    }
  };

  const handleDeleteAssignment = (id, regionName) => {
    setDeleteModal({ open: true, assignmentId: id, regionName });
  };

  const confirmDeleteAssignment = async () => {
    if (!deleteModal.assignmentId) return;
    setLoading(true);
    try {
      const res = await axiosInstance.delete(
        `${Admin_Parivartan_BDM}/${deleteModal.assignmentId}`,
      );
      if (res.data.success) {
        toast.success('Assignment deleted');
        refetch();
      } else {
        toast.error(res.data.message || 'Failed to delete assignment');
      }
    } catch {
      toast.error('Failed to delete assignment');
    } finally {
      setLoading(false);
      setDeleteModal({ open: false, assignmentId: null, regionName: '' });
    }
  };

  return (
    <>
      {/* <tr className="hover cursor-pointer" onClick={onToggleExpand}>
        <td colSpan={6} className="p-4">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-semibold text-base">
                {assignments[0]?.EmployeeName}
              </div>
              <div className="text-sm text-gray-500">
                ID: {assignments[0]?.EmployeeId}
              </div>
            </div>
            <div className="flex items-center gap-1 text-sm text-gray-500 select-none">
              <span>Total Regions: {assignments.length}</span>
              {isExpanded ? (
                <ChevronUp size={16} className="transition-transform" />
              ) : (
                <ChevronDown size={16} className="transition-transform" />
              )}
            </div>
          </div>
        </td>
      </tr> */}

      {/* {isExpanded && (
        <tr>
          <td colSpan={6} className="p-0">
            <div className="bg-base-200 rounded-b-lg p-4 border-t border-base-300 shadow-sm animate-fade-in mb-4">
              <table className="table w-full text-sm">
                <thead>
                  <tr>
                    <th>Region</th>
                    <th>Project</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {assignments.map((a) => (
                    <tr key={a.id}>
                      <td>{a.RegionName}</td>
                      <td>{a.Project}</td>
                      <td>{a.role}</td>
                      <td>
                        <span
                          className={`badge ${
                            a.is_active === 'Active'
                              ? 'badge-success'
                              : 'badge-ghost'
                          }`}
                        >
                          {a.is_active}
                        </span>
                      </td>
                      <td className="text-right space-x-2">
                        <button
                          className="btn btn-xs btn-outline btn-info"
                          onClick={() =>
                            handleToggleStatus(a.RegionId, a.is_active)
                          }
                        >
                          {a.is_active === 'Active' ? 'Deactivate' : 'Activate'}
                        </button>
                        <button
                          className="btn btn-xs btn-outline btn-error"
                          onClick={() =>
                            handleDeleteAssignment(a.id, a.RegionName)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )} */}

      {/* Toggle Status Modal */}
      {/* {statusModal.open && (
        <div className="modal modal-open">
          <div className="modal-box max-w-sm">
            <h3 className="font-bold text-lg mb-4">
              {statusModal.currentStatus === 'Active'
                ? 'Deactivate'
                : 'Activate'}{' '}
              Region Assignment
            </h3>
            <p>
              Are you sure you want to{' '}
              <span className="font-semibold">
                {statusModal.currentStatus === 'Active'
                  ? 'deactivate'
                  : 'activate'}
              </span>{' '}
              this region assignment?
            </p>
            <div className="modal-action">
              <button
                className="btn btn-ghost"
                onClick={() =>
                  setStatusModal({
                    open: false,
                    regionId: '',
                    currentStatus: '',
                  })
                }
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className={`btn ${
                  statusModal.currentStatus === 'Active'
                    ? 'btn-error'
                    : 'btn-success'
                }`}
                onClick={confirmToggleStatus}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="loading loading-spinner loading-sm"></span>
                    Saving...
                  </>
                ) : statusModal.currentStatus === 'Active' ? (
                  'Deactivate'
                ) : (
                  'Activate'
                )}
              </button>
            </div>
          </div>
        </div>
      )} */}

      {/* Delete Assignment Modal */}
      {/* {deleteModal.open && (
        <div className="modal modal-open">
          <div className="modal-box max-w-sm">
            <h3 className="font-bold text-lg mb-4">Delete Region Assignment</h3>
            <p>
              Are you sure you want to delete the assignment for region{' '}
              <span className="font-semibold">{deleteModal.regionName}</span>?
            </p>
            <div className="modal-action">
              <button
                className="btn btn-ghost"
                onClick={() =>
                  setDeleteModal({
                    open: false,
                    assignmentId: null,
                    regionName: '',
                  })
                }
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="btn btn-error"
                onClick={confirmDeleteAssignment}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="loading loading-spinner loading-sm"></span>
                    Deleting...
                  </>
                ) : (
                  'Delete'
                )}
              </button>
            </div>
          </div>
        </div>
      )} */}
      {/* Main Row */}
      <TableRow hover sx={{ cursor: 'pointer' }} onClick={onToggleExpand}>
        <TableCell colSpan={6}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography fontWeight={600} fontSize="1rem">
                {assignments[0]?.EmployeeName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ID: {assignments[0]?.EmployeeId}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2" color="text.secondary">
                Total Regions: {assignments.length}
              </Typography>
              {isExpanded ? (
                <ChevronUp size={18} />
              ) : (
                <ChevronDown size={18} />
              )}
            </Box>
          </Box>
        </TableCell>
      </TableRow>

      {/* Expanded Region Assignments */}
      {isExpanded && (
        <TableRow>
          <TableCell colSpan={6} sx={{ p: 0 }}>
            <Box
              sx={{
                bgcolor: 'grey.100',
                borderBottomLeftRadius: 2,
                borderBottomRightRadius: 2,
                p: 2,
                borderTop: 1,
                borderColor: 'grey.300',
                boxShadow: 1,
                mb: 2,
                animation: 'fadeIn 0.3s',
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Region</TableCell>
                    <TableCell>Project</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assignments.map((a) => (
                    <TableRow key={a.id}>
                      <TableCell>{a.RegionName}</TableCell>
                      <TableCell>{a.Project}</TableCell>
                      <TableCell>{a.role}</TableCell>
                      <TableCell>
                        <Chip
                          label={a.is_active}
                          color={a.is_active === 'Active' ? 'success' : 'default'}
                          size="small"
                          variant={a.is_active === 'Active' ? 'filled' : 'outlined'}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                          <Button
                            size="small"
                            variant="outlined"
                            color={a.is_active === 'Active' ? 'warning' : 'success'}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleStatus(a.RegionId, a.is_active);
                            }}
                          >
                            {a.is_active === 'Active' ? 'Deactivate' : 'Activate'}
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteAssignment(a.id, a.RegionName);
                            }}
                          >
                            Delete
                          </Button>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableCell>
        </TableRow>
      )}

      {/* Toggle Status Modal */}
      <Dialog
        open={statusModal.open}
        onClose={() =>
          setStatusModal({ open: false, regionId: '', currentStatus: '' })
        }
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {statusModal.currentStatus === 'Active'
            ? 'Deactivate'
            : 'Activate'}{' '}
          Region Assignment
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to{' '}
            <Box component="span" fontWeight="bold" display="inline">
              {statusModal.currentStatus === 'Active'
                ? 'deactivate'
                : 'activate'}
            </Box>{' '}
            this region assignment?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setStatusModal({ open: false, regionId: '', currentStatus: '' })
            }
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={confirmToggleStatus}
            color={statusModal.currentStatus === 'Active' ? 'error' : 'success'}
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Saving...
              </>
            ) : statusModal.currentStatus === 'Active' ? (
              'Deactivate'
            ) : (
              'Activate'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Assignment Modal */}
      <Dialog
        open={deleteModal.open}
        onClose={() =>
          setDeleteModal({
            open: false,
            assignmentId: null,
            regionName: '',
          })
        }
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Region Assignment</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the assignment for region{' '}
            <Box component="span" fontWeight="bold" display="inline">
              {deleteModal.regionName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setDeleteModal({
                open: false,
                assignmentId: null,
                regionName: '',
              })
            }
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteAssignment}
            color="error"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RegionAssignmentTableRow;
